import { types } from "../types/types";

const initialState = {
  manualDocumentInfo: {},
};

export const manualDocumentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.getManualDocument:
      return {
        ...state,
        manualDocumentInfo: { ...action.payload },
      };
    case types.authLogout:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
